export const SNOWPACK_PUBLIC_ENV = "PROD";
export const SNOWPACK_PUBLIC_API_URL = "https://lithos-philia.com";
export const SNOWPACK_PUBLIC_ASSETS_ROUTE = "https://lithos-philia.com/wp/wp-content/uploads/";
export const SNOWPACK_PUBLIC_REST_ROUTE = "https://lithos-philia.com/wp-json/litec/";
export const SNOWPACK_PUBLIC_TEN_URL = "https://tennnone.com";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;